import { useApi } from "utils";
import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { DataTypePaging } from "types";
import { FillterType } from "../..";
import { CountList } from "../../type";

export function useList({ 
  page,
  limit, 
  start_date,
  end_date,
  location_id,
  status_id
}: FillterType) {

  const defaultValue = {
    payload: [],
    pagination_data: {
      page: 0,
      pages: 0,
      size: 0,
      total: 0
    }
  }

  const api = useApi();
  const [data, setData] = useState<DataTypePaging<CountList>>(defaultValue);
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {}
  if (page) params.page = page;
  if (limit) params.limit = limit;
  if (start_date) params.start_date = start_date;
  if (end_date) params.end_date = end_date;
  if (location_id) params.location_id = location_id;
  if (status_id) params.count_status = status_id;

  const fetchUrl = () => { return api.get("/invcount/register_count?", {params}) }

  const fetchData = () => {
    setLoading(true);

    fetchUrl()
    .then((res: SuccessFetch<DataTypePaging<CountList>>) => setData(res.data))
    .catch(() => setData(defaultValue))
    .finally(() => setLoading(false));
  }

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData(defaultValue);
      setLoading(true);
    }
    // eslint-disable-next-line
  }, [page, limit, start_date, end_date, location_id, status_id ]);

  return { data, isLoading, refetch }
}
